import api from '@/lib/api';

export default {

  async getClient({ commit }, id) {
    const payload = await api.client.getClient(id);
    commit('clientsList', payload);
    return payload;
  },

  async saveClient({ commit, state }, id) {
    const {
      tradeName,
      name,
      rfc,
    } = state;
    const payload = await api.client.saveClient(id, { tradeName, name, rfc });
    commit('setValues', payload);
    return payload;
  },

};
